export default __webpack_public_path__ + "locales/tr/HotkeysPanel.json?hash=018ac4d160db8a26fcbd54454a45cd15";